import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

const graphqlUrl =
  process.env.NODE_ENV === "production"
    ? "/graphql"
    : "http://localhost:4000/graphql";

export const client = new ApolloClient({
  link: new HttpLink({
    uri: graphqlUrl,
    credentials: "include",
  }),
  cache: new InMemoryCache(),
});